export const offersEn = [
  "Automation",
  "Artificial intelligence",
  "Real-time threat-intelligence update",
  "AAA-accredited compliance & cybersecurity courses",
  "Access to risks posed by third-party vendors",
  "Vulnerability scans",
  "Penetration tests",
  "Easy means of risk assessment where users can easily access their risks and compute risk score",
  "PCI scan on user infrastructure to scan and report vulnerabilities and cyber threats real time",
  "Recommended actions to be taken to ensure cybersecurity, background checks, cybersecurity policy training for employees, and more.",
];

export const offersFr = [
  "Automatisation",
  "Intelligence artificielle",
  "Mises à jour en temps réel sur les menaces",
  "Formations accréditées AAA en conformité et cybersécurité",
  "Accès aux risques liés aux fournisseurs tiers",
  "Analyses de vulnérabilités",
  "Tests d’intrusion",
  "Moyens simples d’évaluation des risques permettant aux utilisateurs d’accéder facilement à leurs risques et de calculer leur score de risque",
  "Scan PCI de l’infrastructure des utilisateurs pour analyser et signaler en temps réel les vulnérabilités et les cybermenaces",
  "Actions recommandées pour garantir la cybersécurité, vérifications des antécédents, formations en politiques de cybersécurité pour les employés, et plus encore.",
];

export const statsEn = [
  {
    label: "Total Users",
    value: 500000,
    suffix: "+",
  },
  { label: "Available countries", value: 30, suffix: "+" },
  { label: "Customers Satisfaction", value: 99, suffix: "%" },
  { label: "data breach prevented", value: 1000, suffix: "+" },
];

export const statsFr = [
  {
    label: "Nombre total d’utilisateurs",
    value: 500000,
    suffix: "+",
  },
  { label: "Pays disponibles", value: 30, suffix: "+" },
  { label: "Satisfaction des clients", value: 99, suffix: "%" },
  { label: "violations de données évitées", value: 1000, suffix: "+" },
];

export const itemsEn = [
  {
    title: "Our Mission",
    content:
      "To help businesses stay secure and compliant with smart, and automated solutions.",
  },
  {
    title: "Our Vision",
    content:
      "To lead in AI-driven security, empowering businesses with automated compliance and cybersecurity solutions.",
  },
  {
    title: "Our Value",
    content:
      "Integrity: We uphold the highest standards of ethics and transparency.Reliability | Agility | Excellence",
  },
];
export const itemsFr = [
  {
    title: "Notre mission",
    content:
      "Aider les entreprises à rester sécurisées et conformes grâce à des solutions intelligentes et automatisées.",
  },
  {
    title: "Notre vision",
    content:
      "Être un leader de la sécurité basée sur l’IA, en donnant aux entreprises les moyens d’adopter des solutions automatisées de conformité et de cybersécurité.",
  },
  {
    title: "Nos valeurs",
    content:
      "Intégrité : Nous respectons les plus hauts standards d’éthique et de transparence. Fiabilité | Agilité | Excellence",
  },
];
